import styled from 'styled-components';

export const AssetGradientCardStyled = styled.div<{disabled?: boolean}>`
    position: relative;
    overflow: hidden;
    width: 56px;
    height: 56px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 16px;
    pointer-events: ${({ disabled }) => disabled ? 'none' : 'auto'};
    z-index: 1;
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    will-change: transform;

    &:after {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: block;
        content: '';
        background: linear-gradient(136deg, rgba(255, 255, 255, 0.15) 14.24%, rgba(255, 255, 255, 0.00) 87.86%);
    }

    .bg {
        opacity: 0.5;
        filter: blur(15px);
        -webkit-filter: blur(15px);
        transform: translate3d(0, 0, 0);
        will-change: transform;
    }

    & .bg-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    & .icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;